export default {"src":"/_next/static/media/Progress.24584456.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};